<!-- <section class="row mb-4 pl-2 border-left">
  <section class="col-sm-12 col-md-6 mb-4 mt-4">
    <h2 class="h6 font-weight-bold mb-2">Información adicional</h2>
    <div class="row">
      <div class="col-sm-12 col-md-12 mt-3">
        <div *ngIf="observaciones_prestador != null">
          <label class="small text-muted mb-0"> Motivo Prestador<br/>
            <strong class="h6 text-dark font-weight-bold">
              {{observaciones_prestador}}
            </strong>
          </label><br/>
        </div>
      <ng-container *ngIf="observaciones_prestador !== null">
        <div>
          <label class="small text-muted mb-0" >
            Motivo
            <br>
          <strong class="h6 text-dark font-weight-bold">
            {{observaciones}}
          </strong>
          </label>
        </div>
      </ng-container>

      </div>
      <div class="col-sm-12 col-md-4 mt-2">
        <label class="small text-muted mb-0"
          *ngIf="datoSolicitudSharedModel.data.tipo_solicitud_id === suspension">Fecha
          inicio suspensión<br><strong
            class="h6 text-dark font-weight-bold">{{informacionEstablecimiento.fecha_inicio_suspension
            | date:'d/MMM/yyyy'}}</strong></label>
      </div>
      <div class="col-sm-12 col-md-4 mt-2">
        <label class="small text-muted mb-0"
          *ngIf="datoSolicitudSharedModel.data.tipo_solicitud_id === suspension">Fecha
          fin suspensión<br><strong
            class="h6 text-dark font-weight-bold">{{informacionEstablecimiento.fecha_fin_suspension
            | date:'d/MMM/yyyy'}}</strong></label>
      </div>
      <div class="col-sm-12 col-md-12 mt-2">
      </div>
      <div class="col-sm-12 col-md-12 mt-2"
        *ngIf="(datoSolicitudSharedModel.data.tipo_solicitud_id === reactivacion) && documentos && documentos.length > 0">
        <ng-continer *ngIf="disponibilidad_documento===true">
          <h6 class="h6 font-weight-bold mb-2">Documentos adjuntos</h6>
          <ul class="list-group">
            <ng-container *ngFor="let item of documentos; let i = index;">
              <li *ngIf="item.flag == 'Actual'" class="list-group-item d-flex justify-content-between align-items-center p-3">
                <div *ngFor="let document of item.preguntas">
                    <div *ngIf="document.nombre_archivo != null">
                      <header>
                        <h2 class="font-weight-bold m-0 h5">{{document.nombre_archivo}}</h2>
                      </header>
                      <div>
                        <img (click)="downloadFile(document)" class="pointer" width="27" height="27"
                          src="../../../../../assets/icons/doc.png" />
                      </div>
                    </div>
                </div>
              </li>
            </ng-container>
          </ul>
        </ng-continer>
        <br />
        <ng-continer *ngIf="InformacionPago.Texto_Informacion_pago_fontur != null">
        <section class="row mb-4 pl-2 border-left">
          <section class="col-sm-12 col-md-12 mb-4 mt-4">
            <label class="small text-muted mb-0" >Información acerca de pago de verificación automatica multa fontur</label>
            <div class="row">
              <ul class="list-group col-sm-12 col-md-10">
                <li class="list-group-item small d-flex justify-content-between">
                  <label class="pr-3">Fecha y Hora de la consulta</label>
                  <label>{{InformacionPago.fecha_Ultima_Confirmacion_pago | date:'d/MMM/yyyy, h:mm a'}}</label>
                </li>
                <li class="list-group-item small d-flex justify-content-between">
                  <label class="pr-3">Mensaje</label>
                  <p>{{InformacionPago.Texto_Informacion_pago_fontur}}</p>
                </li>
              </ul>
            </div>
          </section>
        </section>
        </ng-continer>
      </div>
    </div>
  </section>
</section> -->

<section class="row mb-4 pl-2 border-left">
  <section class="col-sm-12 col-md-6 mb-4 mt-4">
    <h2 class="h6 font-weight-bold mb-2">Información adicional</h2>
    <div class="row">

      <!-- Sección de Observaciones -->
      <div class="col-sm-12 col-md-12 mt-3" *ngIf="observaciones_prestador != null">
        <label class="small text-muted mb-0"> Motivo Prestador<br/>
          <strong class="h6 text-dark font-weight-bold">{{observaciones_prestador}}</strong>
        </label>
      </div>

     <br/>
     <div class="col-sm-12 col-md-12 mt-3"  *ngIf="observaciones != null">
      <label class="small text-muted mb-0 mt-2" >
        Motivo<br>
        <strong class="h6 text-dark font-weight-bold">{{observaciones}}</strong>
      </label>
     </div>

      <!-- Sección de Fechas de Suspensión -->
      <div class="col-sm-12 col-md-4 mt-2" *ngIf="datoSolicitudSharedModel.data.tipo_solicitud_id === suspension">
        <label class="small text-muted mb-0">Fecha inicio suspensión<br>
          <strong class="h6 text-dark font-weight-bold">{{informacionEstablecimiento.fecha_inicio_suspension | date:'d/MMM/yyyy'}}</strong>
        </label>
      </div>
      <div class="col-sm-12 col-md-4 mt-2" *ngIf="datoSolicitudSharedModel.data.tipo_solicitud_id === suspension">
        <label class="small text-muted mb-0">Fecha fin suspensión<br>
          <strong class="h6 text-dark font-weight-bold">{{informacionEstablecimiento.fecha_fin_suspension | date:'d/MMM/yyyy'}}</strong>
        </label>
      </div>

      <!-- Sección de Documentos Adjuntos -->
      <div class="col-sm-12 col-md-12 mt-2" *ngIf="(datoSolicitudSharedModel.data.tipo_solicitud_id === reactivacion) && documentos && documentos.length > 0">
        <ng-container *ngIf="disponibilidad_documento===true">
          <h6 class="h6 font-weight-bold mb-2">Documentos adjuntos</h6>
          <ul class="list-group">
            <ng-container *ngFor="let item of documentos; let i = index;">
              <li *ngIf="item.flag == 'Actual'" class="list-group-item d-flex justify-content-between align-items-center p-3">
                <div *ngFor="let document of item.preguntas">
                  <div *ngIf="document.nombre_archivo != null">
                    <header>
                      <h2 class="font-weight-bold m-0 h5">{{document.nombre_archivo}}</h2>
                    </header>
                    <div>
                      <img (click)="downloadFile(document)" class="pointer" width="27" height="27" src="../../../../../assets/icons/doc.png" />
                    </div>
                  </div>
                </div>
              </li>
            </ng-container>
          </ul>
        </ng-container>
      </div>

      <!-- Sección de Información de Pago -->
      <div class="col-sm-12 col-md-12 mt-2" *ngIf="InformacionPago.Texto_Informacion_pago_fontur != null">
        <section class="row mb-4 pl-2 border-left">
          <section class="col-sm-12 col-md-12 mb-4 mt-4">
            <!-- <label class="small text-muted mb-0">Información acerca de pago de verificación automática multa fontur</label> -->
            <h5 style="font-weight: bold;">Información acerca de pago de verificación automática multa fontur</h5>
            <div class="row">
              <ul class="list-group col-sm-12 col-md-10">
                <li class="list-group-item small d-flex justify-content-between">
                  <label class="pr-3">Fecha y Hora de la consulta</label>
                  <label>{{InformacionPago.fecha_Ultima_Confirmacion_pago | date:'d/MMM/yyyy, h:mm a'}}</label>
                </li>
                <li class="list-group-item small d-flex justify-content-between">
                  <label class="pr-3">Mensaje</label>
                  <p>{{InformacionPago.Texto_Informacion_pago_fontur}}</p>
                </li>
              </ul>
            </div>
          </section>
        </section>
      </div>

    </div>
  </section>
</section>

